import React, { useContext } from 'react'
import { useHistory, Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import ContentDossierToolbar from '@/feature/ContentDossier/Toolbar'
import { KeDoContext } from '../../../kedo-context'
import { useChat } from '../../../context/ChatContext'
import {
    BreadcrumbLink,
    BreadcrumbStatic,
    StyledBreadcrumbs,
} from '@/Components/Elements/StyledComponents/Breadcrumbs'

type Props = {
    dossier: any
    defdossier: any
    showBreadcrumb?: boolean
    onDeleteSuccess?: () => void
    subscribed?: boolean
    favorite?: boolean
    items?: any
    content?: any
}

const DefaultHeader = ({
    dossier,
    defdossier,
    showBreadcrumb,
    onDeleteSuccess,
    subscribed,
    favorite,
    items,
    content,
}: Props) => {
    const kedo = useContext(KeDoContext)
    const { setIsChatOpen, setChatData } = useChat()

    const handleChatOpen = () => {
        setChatData({
            dossier,
            defdossier,
            items,
            content,
        })
        setIsChatOpen(true)
    }

    const history = useHistory()

    const defaultQuery = defdossier?.settings?.query_settings?.default_query
        ? `?dossierQuery=${defdossier?.settings?.query_settings?.default_query}`
        : ''

    const isChatEnabled = !!kedo?.env()?.getModule('artificialintelligence')?.id
    const canUseChat =
        kedo.isAdmin() ||
        ((kedo.isEnvironmentAdmin() || kedo.env().hasCredential('ai_chat')) &&
            isChatEnabled)

    return (
        <Box className="sticky dossier_info_header">
            <Grid container alignItems="flex-start" wrap="nowrap" spacing={2}>
                <Grid size={12} className="dossierInfo">
                    {showBreadcrumb !== false ? (
                        <Box sx={{ my: 1 }}>
                            <StyledBreadcrumbs aria-label="breadcrumb">
                                <BreadcrumbLink component={Link} to={`/`}>
                                    {kedo.t('Home')}
                                </BreadcrumbLink>
                                <BreadcrumbLink
                                    component={Link}
                                    to={`/defdossier/${dossier.def_dossier_id}${defaultQuery}`}
                                >
                                    {kedo
                                        .env()
                                        .translateItem(
                                            defdossier,
                                            'defdossier',
                                            true
                                        )}
                                </BreadcrumbLink>
                                <BreadcrumbStatic className="current">
                                    {dossier?.summary}
                                </BreadcrumbStatic>
                            </StyledBreadcrumbs>
                        </Box>
                    ) : null}

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <Typography variant="h4" component="h1">
                            {dossier && dossier.summary
                                ? dossier.summary
                                : dossier?.id}
                        </Typography>

                        {canUseChat ? (
                            <Tooltip title="Chat">
                                <IconButton
                                    size="small"
                                    onClick={handleChatOpen}
                                    aria-label="Open chat"
                                >
                                    💬
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </Box>

                    <Box sx={{ mt: 1 }} />
                </Grid>

                <Grid size={'auto'} sx={{ textAlign: 'right' }}>
                    <ContentDossierToolbar
                        onDeleteSuccess={onDeleteSuccess}
                        favorite={favorite}
                        subscribed={subscribed}
                        kedo={kedo}
                        id={dossier.id}
                        defdossier={defdossier}
                        dossier={dossier}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default DefaultHeader
